import React from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  FaCalendar,
  FaMoneyBill,
  FaCalendarCheck,
  FaUser,
  FaUserMd,
  FaBusinessTime,
  FaBroadcastTower,
  FaFileInvoice,
} from 'react-icons/fa';
import history from '../../services/history';

const triggerEvent = window.matchMedia('(hover: hover)').matches
  ? ['hover', 'focus']
  : ['focus'];

const AgendaOverlayButtons = ({
  setShowSearchMedicosModal,
  setShowSearchPatientsModal,
  setShowGeraHorarios,
  setShowEncaixeModal,
  setShowGravaAgenda,
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const date = searchParams.get('date');

  return (
    <>
      <Row className="justify-content-center g-2">
        <Col xs={6} sm={1}>
          <OverlayTrigger
            trigger={triggerEvent}
            overlay={<Tooltip>Cadastrar Médico</Tooltip>}
          >
            <span className="d-inline-block">
              <Button
                onClick={() => setShowSearchMedicosModal(true)}
                size="sm"
                variant="dark"
              >
                <FaUserMd style={{ width: 18, height: 18 }} />
              </Button>
            </span>
          </OverlayTrigger>
        </Col>
        <Col xs={6} sm={1}>
          <OverlayTrigger
            trigger={triggerEvent}
            overlay={<Tooltip>Cadastrar Paciente</Tooltip>}
          >
            <span className="d-inline-block">
              <Button
                onClick={() => setShowSearchPatientsModal(true)}
                size="sm"
                variant="success"
              >
                <FaUser style={{ width: 18, height: 18, color: '#FFD600' }} />
              </Button>
            </span>
          </OverlayTrigger>
        </Col>
        <Col xs={6} sm={1}>
          <OverlayTrigger
            trigger={triggerEvent}
            overlay={<Tooltip>Atividades do Paciente</Tooltip>}
          >
            <span className="d-inline-block">
              <Button
                onClick={() => history.push(`/frmatv`)}
                size="sm"
                variant="warning"
              >
                <FaBroadcastTower style={{ width: 18, height: 18 }} />
              </Button>
            </span>
          </OverlayTrigger>
        </Col>
        <Col xs={6} sm={1}>
          <OverlayTrigger
            trigger={triggerEvent}
            overlay={<Tooltip>Gerar Horários</Tooltip>}
          >
            <span className="d-inline-block">
              <Button onClick={() => setShowGeraHorarios(true)} size="sm">
                <FaCalendarCheck style={{ width: 18, height: 18 }} />
              </Button>
            </span>
          </OverlayTrigger>
        </Col>
        <Col xs={6} sm={1}>
          <OverlayTrigger
            trigger={triggerEvent}
            overlay={<Tooltip>Encaixar Horário</Tooltip>}
          >
            <span className="d-inline-block">
              <Button
                onClick={() => setShowEncaixeModal(true)}
                size="sm"
                variant="danger"
              >
                <FaBusinessTime style={{ width: 18, height: 18 }} />
              </Button>
            </span>
          </OverlayTrigger>
        </Col>
        <Col xs={6} sm={1}>
          <OverlayTrigger
            trigger={triggerEvent}
            overlay={<Tooltip>Fechamento Diário</Tooltip>}
          >
            <span className="d-inline-block">
              <Button
                onClick={() => history.push('/fechamento', { data: date })}
                size="sm"
                variant="info"
              >
                <FaMoneyBill
                  style={{ width: 18, height: 18, color: '#3dee15' }}
                />
              </Button>
            </span>
          </OverlayTrigger>
        </Col>
        <Col xs={6} sm={1}>
          <OverlayTrigger
            trigger={triggerEvent}
            overlay={<Tooltip>Guia de Convenio</Tooltip>}
          >
            <span className="d-inline-block">
              <Button
                onClick={() => history.push('/relatorios-faturamento', { data: date })}
                size="sm"
                variant="primary"
              >
                <FaFileInvoice
                  style={{ width: 18, height: 18, color: '#FFD600' }}
                />
              </Button>
            </span>
          </OverlayTrigger>
        </Col>
        <Col xs={6} sm={1}>
          <OverlayTrigger
            trigger={triggerEvent}
            overlay={<Tooltip>Agenda Diária</Tooltip>}
          >
            <span className="d-inline-block">
              <Button
                onClick={() => history.push('/agenda-diaria', { data: date })}
                size="sm"
                variant="secondary"
              >
                <FaCalendar style={{ width: 18, height: 18 }} />
              </Button>
            </span>
          </OverlayTrigger>
        </Col>
        <Col xs={6} sm={1}>
          <Button size="sm" onClick={() => setShowGravaAgenda(true)}>
            Gravar
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default AgendaOverlayButtons;
